export const initialState = {
  filters: {},
  questionnaires: [],
  questionnaire: {},
  loading: false
};
